export const socialsData = {
  github: "https://github.com/Najd-Feki",
  linkedIn: "https://www.linkedin.com/in/najd-feki-a10353202/",
  medium: "https://medium.com/@najd.feki",
  stackOverflow: "https://stackoverflow.com/users/16851177/najd-feki",
  gitlab: "https://gitlab.com/najdfeki",
};
